import { useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';

interface DialogConfirmProps {
  open: boolean;
  title: string;
  description: string;
  handleClose: () => void;
  handleConfirm: () => void;
  confirmationPhrase?: string;
}
const DialogConfirm = ({
  open,
  title,
  description,
  handleClose,
  handleConfirm,
  confirmationPhrase,
}: DialogConfirmProps) => {
  const [confirmInput, setConfirmInput] = useState<string>('');

  const handleConfirmation = () => {
    handleConfirm();
    handleClose();
  };

  const validatePhrase = () => {
    return confirmInput !== confirmationPhrase;
  };

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={handleClose}
      aria-labelledby="confirmation-dialog"
      aria-describedby="confirmation-dialog-description"
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
      }}
    >
      <DialogTitle id="confirmation-dialog" sx={{ fontSize: '18px' }} color="error">
        {title}
      </DialogTitle>
      <DialogContent>
        <Alert severity="error" sx={{ mb: 4 }}>
          {description}
        </Alert>
        {confirmationPhrase && (
          <TextField
            fullWidth
            id="confirm-phrase"
            label={`Enter '${confirmationPhrase}' to proceed.`}
            variant="outlined"
            sx={{ mb: 4 }}
            value={confirmInput}
            onChange={(e) => setConfirmInput(e.target.value)}
          />
        )}
        <DialogActions>
          <Button autoFocus variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={handleConfirmation}
            disabled={typeof confirmationPhrase !== 'undefined' ? validatePhrase() : false}
          >
            Confirm
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default DialogConfirm;
